import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalBody, Table } from 'reactstrap'
import VehicleTopicsForm from './VehicleTopicsForm'
import RosSetupVehicleForm from './RosSetupVehicleForm'
import { useDispatch } from 'react-redux'
import { getSetup, updateSetup } from 'features/dashboard/RosSetup.actionTypes'
import { useSelector } from 'react-redux'
import { selectors } from 'features/dashboard'

const RosSetupVehDev = ({
    setup,
    handleUpdate,
    tempAdd,
    vehicles,
    modalSmall,
    newList, 
    setNewList,
    handleDelete,
    handleFieldUpdate,
    toggleSmall,
    handleAdd,
}) => {
    const dispatch = useDispatch()
    const [vehicle, setVehicle] = useState(null)
    const [modal, setModal] = useState(false)
    const setupStore = useSelector(selectors.getSetup)
    const [removeModal, setRemoveModal] = useState(false)
    const toggle = () => setModal(!modal)
    const [currentVehicle, setCurrentVehicle] = useState({})
    const toggleRemove = () => setRemoveModal(!removeModal)
    const setupList = setupStore?.setups?.results?.find((item) => item.uuid === setup.uuid) || setup
   

    useEffect(() => {
        setNewList((prevList) => {  
            const foundItem = vehicles?.find((item) => item.uuid === tempAdd[0]?.uuid)
            return foundItem ? [...prevList, foundItem] : prevList
        })
    }, [tempAdd])  // eslint-disable-line react-hooks/exhaustive-deps

   
    useEffect(() => {
        if (!modalSmall) {
            setCurrentVehicle({})
        }
    }, [modalSmall])
    return (
        <div className="big-org-container" style={{ padding: '0', marginTop: '1px' }}>
            <div className="my-1">
                <RosSetupVehicleForm
                    setup={setup}
                    modal={modalSmall}
                    toggle={toggleSmall}
                    vehicles={vehicles}
                    initialValues={currentVehicle[0]}
                    team={setup?.team?.uuid}
                    handleAdd={handleAdd}
                    handleUpdate={handleFieldUpdate}
                />
            </div>

            <Table role="table" bordered className="my-custom-table border-0">
                {setupList?.vehicles.length > 0 ? (
                    <>
                        {' '}
                        <thead>
                            <tr>
                                <th className="react-table-header">Vehicle Name</th>
                                <th className="react-table-header">External ID</th>
                                <th className="react-table-header">Prefix</th>
                                <th className="react-table-header">Serial number</th>
                                <th className="react-table-header">Manufacturer</th>
                                {(setup.integration_type === 'ROS' ||
                                    setup.integration_type === 'NOOVELIA') && (
                                    <th className="react-table-header"></th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {setupList.vehicles.map((veh, index) => (
                                <tr key={index}>
                                    <td className="react-table-style">
                                        {veh?.vehicle.verbose_name}
                                    </td>
                                    <td className="react-table-style">
                                        {veh?.vehicle.external_identifier || '-'}
                                    </td>
                                    <td className="react-table-style">{veh.prefix}</td>
                                    <td className="react-table-style">
                                        {veh.vehicle.serial_number}
                                    </td>
                                    <td className="react-table-style">
                                        {veh.vehicle.manufacturer}
                                    </td>
                                    {(setup.integration_type === 'ROS' ||
                                        setup.integration_type === 'NOOVELIA') && (
                                        <td
                                            className="react-table-style"
                                            data-testid="edit"
                                            style={{ whiteSpace: 'nowrap' }}
                                        >
                                            <img
                                                style={{ cursor: 'pointer' }}
                                                src="/svgs/organization/buttons/trash.svg"
                                                alt="trash"
                                                onClick={() => {
                                                    setVehicle(veh)
                                                    toggleRemove()
                                                }}
                                            />
                                            <img
                                                style={{
                                                    marginLeft: '1rem',
                                                    cursor: 'pointer',
                                                }}
                                                src="/svgs/trigger-actions/edit.svg"
                                                alt="edit"
                                                onClick={() => {
                                                    setVehicle(veh)
                                                    toggle()
                                                }}
                                            />
                                        </td>
                                    )}
                                </tr>
                            ))}
                            {newList?.map((veh, index) => (
                                <tr key={index}> 
                                    <td className="react-table-style">{veh?.verbose_name}</td>
                                    <td className="react-table-style">
                                        {veh?.external_identifier || '-'}
                                    </td>
                                    <td className="react-table-style">{tempAdd?.prefix}</td>
                                    <td className="react-table-style">{veh?.serial_number}</td>
                                    <td className="react-table-style">{veh?.manufacturer}</td>
                                    {newList !== '' && (
                                        <td
                                            className="react-table-style"
                                            data-testid="edit"
                                            style={{ whiteSpace: 'nowrap' }}
                                        >
                                            <img
                                                style={{ cursor: 'pointer' }}
                                                src="/svgs/organization/buttons/trash.svg"
                                                alt="trash"
                                                onClick={() => {
                                                    setNewList(
                                                        newList?.filter(
                                                            (item) => item.uuid !== veh.uuid
                                                        )
                                                    )
                                                    handleDelete(veh.uuid)
                                                }}
                                            />
                                            <img
                                                style={{
                                                    marginLeft: '1rem',
                                                    cursor: 'pointer',
                                                }}
                                                src="/svgs/trigger-actions/edit.svg"
                                                alt="edit"
                                                onClick={() => {
                                                    setCurrentVehicle(tempAdd)
                                                    toggleSmall()
                                                }}
                                            />
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </>
                ) : (
                    <>
                        {' '}
                        <thead>
                            <tr>
                                <th className="react-table-header">Device Name</th>
                                <th className="react-table-header">Model Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="react-table-style">{setup.device_model?.name}</td>
                                <td className="react-table-style">
                                    {setup.device_model?.device_model_type}
                                </td>
                            </tr>
                        </tbody>
                    </>
                )}
            </Table>

            <Modal isOpen={removeModal} toggle={toggleRemove} centered className="remove-modal-org">
                <ModalBody style={{ padding: '24px' }}>
                    <div
                        className="w-100 d-flex justify-content-between"
                        style={{ marginBottom: '16px' }}
                    >
                        <img
                            src="/svgs/modal-icons/trash-icon.svg"
                            alt="obstacle-icon"
                            width="48px"
                            height="48px"
                        />
                        <img
                            src="/svgs/close-icon/x-dark-default.svg"
                            alt="obstacle-icon"
                            width="24px"
                            height="24px"
                            style={{ cursor: 'pointer' }}
                            onClick={toggleRemove}
                        />
                    </div>
                    <div className="d-flex flex-column">
                        <span className="org-modal-header">Delete vehicle</span>
                        <span className="org-modal-text">
                            Are you sure you want to delete this vehicle? This action cannot be
                            undone.
                        </span>
                    </div>
                    <div
                        style={{ marginTop: '40px' }}
                        className={`d-flex w-100 justify-content-between align-items-center`}
                    >
                        <Button
                            className="org-modal-cancel-button org-modal-btns"
                            onClick={() => {
                                toggleRemove()
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="org-modal-delete-button org-modal-btns"
                            onClick={() => {
                                const vehicles = setupList.vehicles.filter(
                                    (v) => v.vehicle.uuid !== vehicle.vehicle.uuid
                                )
                                const data = {
                                    vehicles,
                                }
                                dispatch(updateSetup({ data, uuid: setup.uuid })).then(
                                    ({ error }) => {
                                        if (!error) {
                                            const uuid = setup.uuid
                                            dispatch(getSetup({ uuid }))
                                            toggleRemove()
                                        }
                                    }
                                )
                            }}
                        >
                            Delete
                        </Button>
                    </div>
                </ModalBody>
            </Modal>

            <VehicleTopicsForm
                modal={modal}
                toggle={toggle}
                vehicle={vehicle}
                handleUpdate={handleUpdate}
            />
        </div>
    )
}

export default RosSetupVehDev
